import { useContext, useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { DashboardContext } from "./DashboardContext"
import { useTranslation } from "react-i18next"

export const ModalHomeworkReport = ({ homework, show, close }) => {
  const { t } = useTranslation()
  const { student } = useContext(DashboardContext)
  const [results, setResults] = useState({})

  useEffect(() => {
    console.log(homework)
    if (!homework) return
    const r = {
      numberOfCorrectAnswer: 0,
      numberOfWongAnswer: 0,
      wrongQuestionNumbers: [],
    }
    const studentAnswers = {}
    homework.homework_answers.forEach((a) => (studentAnswers[a.question_no] = a.answer))
    Object.keys(homework.answers_key).forEach((questionNo) => {
      if (homework.answers_key[questionNo] == studentAnswers[questionNo]) {
        ++r.numberOfCorrectAnswer
      } else {
        ++r.numberOfWongAnswer
        r.wrongQuestionNumbers.push(questionNo)
      }
    })
    setResults(r)
  }, [homework?.id])
  return (
    <Modal size="lg" show={show} onHide={close}>
      <Modal.Header>
        <div className="tw-text-lg tw-font-bold tw-flex tw-justify-between tw-w-full">
          {homework?.name} {homework?.lecture?.course?.name} {t("Homework")}
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="tw-flex tw-justify-center tw-w-full tw-items-center">
          <div className="tw-w-full tw-items-center ">
            <div className="tw-flex tw-items-center tw-justify-between tw-w-full odd:tw-bg-gray-200 p-2">
              <div className="tw-font-bold w-1/3">{t("student_no")}</div>
              <span>{student?.student_no}</span>
            </div>
            <div className="tw-flex tw-items-center tw-justify-between tw-w-full odd:tw-bg-gray-200 p-2">
              <div className="tw-font-bold w-1/3">{t("name")}</div>
              <span>
                {" "}
                {student?.name} {student?.surname}
              </span>
            </div>
            <div className="tw-flex tw-items-center  tw-justify-between  tw-w-full odd:tw-bg-gray-200 p-2 ">
              <div className="tw-font-bold w-1/3">{t("course")}</div>
              <span>{homework?.lecture?.course?.name}</span>
            </div>

            <div className="tw-flex tw-items-center tw-justify-between tw-w-full odd:tw-bg-gray-200 p-2">
              <div className="tw-font-bold w-1/3">{t("number_of_questions")}</div>
              <span>{homework && Object.keys(homework?.answers_key).length}</span>
            </div>
            <div className="tw-flex tw-items-center tw-justify-between tw-w-full odd:tw-bg-gray-200 p-2">
              <div className="tw-font-bold w-1/3">{t("number_of_correct_answers")}</div>
              <span>{results?.numberOfCorrectAnswer}</span>
            </div>
            <div className="tw-flex tw-items-center tw-justify-between tw-w-full odd:tw-bg-gray-200 p-2">
              <div className="tw-font-bold w-1/3">{t("number_of_wrong_answers")}</div>
              <span>{results?.numberOfWongAnswer}</span>
            </div>
            <div className="tw-flex tw-items-center tw-justify-between tw-w-full odd:tw-bg-gray-200 p-2">
              <div className="tw-font-bold w-1/3">{t("wrong_answered_question_no")}</div>
              <span>
                {results?.wrongQuestionNumbers?.join(", ")}
                {results?.wrongQuestionNumbers?.length == 0 && "N/A"}
              </span>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={close}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  )
}
